{
    "type": "module",
    "author": "Team Lettings Application",
    "name": "akelius-lettingapp-frontend",
    "version": "0.0.0",
    "license": "UNLICENSED",
    "repository": {
        "type": "git",
        "url": "git@github.com:Akelius/let-frontend.git"
    },
    "engines": {
        "node": "22.x",
        "npm": "10.x"
    },
    "scripts": {
        "serve:local": "NG_PERSISTENT_BUILD_CACHE=1 ng serve --configuration=local",
        "serve:local:shared": "NG_PERSISTENT_BUILD_CACHE=1 ng serve --configuration=local --disable-host-check --host=0.0.0.0",
        "serve:dev": "NG_PERSISTENT_BUILD_CACHE=1 ng serve --configuration=dev",
        "serve:dev:shared": "NG_PERSISTENT_BUILD_CACHE=1 ng serve --configuration dev --disable-host-check --host 0.0.0.0",
        "build": "npm run task-runner build",
        "build-watch": "NG_PERSISTENT_BUILD_CACHE=1 ng build --watch",
        "test": "ng test --watch  --browsers=MyChromeWithoutSearchSelect",
        "test-ci": "npm run task-runner test:ci",
        "test-headless": "ng test --watch --browsers=ChromeHeadless_without_sandbox",
        "lint": "npm run task-runner lint",
        "package": "npm run task-runner package",
        "deploy": "npm run task-runner deploy",
        "release": "npm run task-runner release",
        "task-runner": "node --import tsx/esm ./tasks.ts"
    },
    "private": true,
    "dependencies": {
        "@akelius/angular-ui-kit": "21.0.0",
        "@akelius/icon-library": "^2.39.16",
        "@akelius/material-theme": "21.0.11",
        "@angular/animations": "21.2.17",
        "@angular/cdk": "21.2.14",
        "@angular/common": "21.2.17",
        "@angular/compiler": "21.2.17",
        "@angular/core": "21.2.17",
        "@angular/forms": "21.2.17",
        "@angular/material": "21.2.14",
        "@angular/material-moment-adapter": "21.2.14",
        "@angular/platform-browser": "21.2.17",
        "@angular/platform-browser-dynamic": "21.2.17",
        "@angular/router": "21.2.17",
        "@angular/service-worker": "21.2.17",
        "@auth0/auth0-angular": "^2.9.0",
        "@iplab/ngx-file-upload": "21.0.0",
        "@ngx-translate/core": "^17.0.0",
        "@ngx-translate/http-loader": "^17.0.0",
        "@sentry/browser": "^10.58.0",
        "moment": "^2.30.1",
        "ngx-google-analytics": "^14.0.1",
        "numeral": "^2.0.6",
        "rxjs": "^7.8.2",
        "ts-md5": "^2.0.1",
        "tslib": "^2.8.1",
        "uuid": "^14.0.0",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@akelius-let/build-tasks": "^17.8.0",
        "@angular-devkit/architect": "^0.2102.16",
        "@angular-devkit/core": "^21.2.16",
        "@angular-eslint/builder": "^21.4.0",
        "@angular-eslint/eslint-plugin": "^21.4.0",
        "@angular-eslint/eslint-plugin-template": "^21.4.0",
        "@angular-eslint/schematics": "^21.4.0",
        "@angular-eslint/template-parser": "^21.4.0",
        "@angular/build": "^21.2.16",
        "@angular/cli": "21.2.16",
        "@angular/compiler-cli": "21.2.17",
        "@sentry/cli": "^3.5.1",
        "@types/archiver": "^7.0.0",
        "archiver": "^7.0.1",
        "@types/eslint": "^9.6.1",
        "@types/fancy-log": "^2.0.2",
        "@types/jasmine": "^6.0.0",
        "@types/node": "^22.19.21",
        "@types/numeral": "2.0.5",
        "@types/uuid": "11.0.0",
        "@typescript-eslint/eslint-plugin": "^8.61.1",
        "@typescript-eslint/parser": "^8.61.1",
        "angular-eslint": "^21.4.0",
        "chalk": "^5.6.2",
        "eslint": "^9.39.4",
        "eslint-plugin-import": "^2.32.0",
        "eslint-plugin-prefer-arrow": "1.2.3",
        "fancy-log": "^2.0.0",
        "jasmine-core": "~6.3.0",
        "jasmine-spec-reporter": "^7.0.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.2.0",
        "karma-cli": "~2.0.0",
        "karma-coverage": "^2.2.1",
        "karma-intl-shim": "^1.0.3",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "^2.2.0",
        "less": "^4.6.6",
        "prettier": "^3.8.4",
        "rimraf": "^6.1.3",
        "sonarqube-scanner": "^4.3.6",
        "tsx": "^4.22.4",
        "typescript": "^5.9.3",
        "typescript-eslint": "^8.61.1"
    },
    "resolutions": {
        "webpack": "^5.0.0"
    }
}
